import React from "react";
import { GreyFleetCheckLicenceOverview } from "pages/licence-checking/grey-fleet/check/overview";
import { DataDisplayRecord } from "components/data-display";
import { GridLayout } from "components/grid/GridLayout";
import { DateToLocal } from "components/dates";
import { ShowHide } from "components/layout";
import { StatusBadge } from "components/status/StatusBadge";
import { Intent } from "@blueprintjs/core";
import PropTypes from "prop-types";

export function GreyFleetCheckLicence({
    isLoading,
    checkData,
    evaluateStatus,
    reloadCheck,
    settings,
    policy,
}) {
    const driverMinAgeFromPolicy =
        policy.find((p) => p.policyRuleKey === "DRIVERAGEMIN")?.values?.[0] ||
        0;
    const driverMaxAgeFromPolicy =
        policy.find((p) => p.policyRuleKey === "DRIVERAGEMAX")?.values?.[0] ||
        0;

    return (
        <div>
            <GreyFleetCheckLicenceOverview
                isLoading={isLoading}
                checkData={checkData}
                evaluateStatus={evaluateStatus}
                reloadCheck={reloadCheck}
            />
            <ShowHide
                evaluator={checkData.licence.result !== null}
                show={
                    <div>
                        <h2>Licence Details</h2>
                        <GridLayout numberOfColumns={4} gap={30}>
                            <DataDisplayRecord
                                header="Name"
                                data={checkData?.employeeName}
                                loading={isLoading}
                            />
                            <DataDisplayRecord
                                header="Licence Number"
                                data={checkData?.licence?.licenceNumber || "-"}
                                loading={isLoading}
                            />
                            <DataDisplayRecord
                                header="Age"
                                data={
                                    checkData.failures?.includes(
                                        "LICENCEAGELIMIT"
                                    ) ? (
                                        <StatusBadge
                                            iconName="error"
                                            intent={Intent.DANGER}
                                            text={
                                                checkData?.licence?.age || "-"
                                            }
                                            showTooltip
                                            tooltipContent={`Driver age policy: Min ${driverMinAgeFromPolicy}, Max ${driverMaxAgeFromPolicy}`}
                                        />
                                    ) : (
                                        checkData?.licence?.age || "-"
                                    )
                                }
                                loading={isLoading}
                            />
                            <DataDisplayRecord
                                header="Photocard Expiry Date"
                                data={
                                    checkData.failures?.includes(
                                        "LICENCEPHOTOCARDEXPIRED"
                                    ) ? (
                                        <StatusBadge
                                            iconName="error"
                                            intent={Intent.DANGER}
                                            text={
                                                <DateToLocal format="DD/MM/YYYY">
                                                    {checkData?.licence
                                                        ?.photocardExpiry ?? ""}
                                                </DateToLocal>
                                            }
                                        />
                                    ) : (
                                        <DateToLocal format="DD/MM/YYYY">
                                            {checkData?.licence
                                                ?.photocardExpiry ?? ""}
                                        </DateToLocal>
                                    )
                                }
                                loading={isLoading}
                            />
                            <DataDisplayRecord
                                header="Short Term Licence"
                                data={
                                    checkData?.licence?.shortTerm ? "Yes" : "No"
                                }
                                loading={isLoading}
                            />
                            <DataDisplayRecord
                                //,ake status badge
                                header="Points"
                                data={
                                    <ShowHide
                                        evaluator={checkData?.failures?.includes(
                                            "LICENCEPOINTLIMIT"
                                        )}
                                        show={
                                            <StatusBadge
                                                iconName="error"
                                                intent={Intent.DANGER}
                                                text={
                                                    checkData?.licence?.points
                                                }
                                                showTooltip
                                                tooltipContent={`Points threshold: ${settings.maximumPointsThreshold}`}
                                            />
                                        }
                                        hide={checkData?.licence?.points}
                                    />
                                }
                                loading={isLoading}
                            />
                            <DataDisplayRecord
                                header="Disqualified"
                                data={
                                    checkData?.licence?.disqualified ? (
                                        <StatusBadge
                                            iconName="error"
                                            intent={Intent.DANGER}
                                            text="Yes"
                                        />
                                    ) : (
                                        "No"
                                    )
                                }
                                loading={isLoading}
                            />
                        </GridLayout>
                    </div>
                }
            />
        </div>
    );
}

GreyFleetCheckLicence.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    checkData: PropTypes.object.isRequired,
    evaluateStatus: PropTypes.func.isRequired,
    reloadCheck: PropTypes.func.isRequired,
    settings: PropTypes.object.isRequired,
    policy: PropTypes.array.isRequired,
};
